import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useUserRelatedDocumentContext } from '../DocumentUserRelatedContext';
import { useReaderContext } from '../../features/ContentRendering/components/ReaderContext';
import { useDocumentContext } from '../DocumentContext';
import ChapterButton from './Button';
import Simplified from './Simplified';
import BookProgress from './BookProgress';

function Footer() {
  const { progressData } = useUserRelatedDocumentContext();
  const { currentChapter, nextChapter, previousChapter } = useReaderContext();
  const { productMeta } = useDocumentContext();
  const theme = useTheme();
  const minimizeChapterNavigation = useMediaQuery(theme.breakpoints.down('sm'));

  if (minimizeChapterNavigation) {
    return <Simplified />;
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ width: '100%', paddingTop: 2, paddingBottom: 6 }}
      >
        <Stack sx={{ flex: 1, alignItems: 'flex-start' }}>
          {previousChapter && (
            <ChapterButton
              chapter={previousChapter}
              direction='previous'
              variant='text'
            />
          )}
        </Stack>
        <Stack sx={{ flex: 1, alignItems: 'flex-end' }}>
          {nextChapter && (
            <ChapterButton
              chapter={nextChapter}
              direction='next'
              variant='text'
            />
          )}
        </Stack>
      </Stack>
      <Stack alignItems='center' sx={{ paddingY: 3, width: '100%' }}>
        <Stack sx={{ color: 'action.active', width: '100%', paddingBottom: 2 }}>
          <BookProgress value={progressData.progressPercentage} />
        </Stack>
        <Stack direction='column' alignItems='center'>
          <Typography component='span' variant='h6' sx={{ lineHeight: '150%' }}>
            {currentChapter?.title}
          </Typography>
          <Typography variant='caption' color='text.secondary'>
            {productMeta?.title}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Footer;
